import { REDUCER_KEY } from './products.consts';

export const removeAllProducts = (): { type: string } => ({
  type: REDUCER_KEY + '/removeAll',
});
